var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkmark"},[_c('fa-layers',{staticClass:"checkmark-circle"},[_c('fa',{staticClass:"checkmark-circle__circle",attrs:{"icon":"circle"}}),_c('fa',{staticClass:"checkmark-circle__checkmark",attrs:{"icon":"check"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }